import React from 'react';

import { Box, Card, Heading, Separator } from '@betterment/samba-react';
import { CardLoader, SambaAutoLink } from '@betterment/shared-components';
import IraContributionMatchSummaries from '@betterment/shared-components/src/components/ira-contributions/IraContributionMatchSummaries';
import { IraContributionSummaries } from '@betterment/shared-components/src/components/ira-contributions/IraContributionSummaries';

import { useActiveIraContributionsAndMatchGrantsByYearQuery } from './hooks';

import { Message as GraphQLMessage } from '../graphql/schema';
import MessageBox from '../Shared/components-v2/message-box/message-box';
import { urlBuilder } from '../Shared/urlBuilder';

const Controller: React.FC<React.PropsWithChildren> = () => {
  const { isLoading, iraContributions, iraContributionMatchGrants, messages } =
    useActiveIraContributionsAndMatchGrantsByYearQuery();

  const hasMatchGrants = Array.isArray(iraContributionMatchGrants) && iraContributionMatchGrants.length > 0;
  const hasValidMessages = messages && messages.length > 0;
  const header = hasMatchGrants ? 'IRA contributions and match' : 'IRA Contributions ';

  if (isLoading) return <CardLoader />;
  if (!iraContributions) return null;

  return (
    <Card css={{ padding: 'space.300', display: 'grid', gap: 'space.300' }}>
      <Card.Header>
        <Heading as="h3" css={{ textStyle: { base: 'title100', md: 'title200' } }}>
          {header}
        </Heading>
      </Card.Header>
      <Separator />
      <Card.Content>
        <Box css={{ display: 'grid', gap: 'space.300', marginTop: 'space.25' }}>
          <IraContributionSummaries iraContributions={iraContributions} />

          {iraContributionMatchGrants && !hasValidMessages && (
            <IraContributionMatchSummaries iraContributionMatchGrants={iraContributionMatchGrants} />
          )}
          {hasValidMessages && (
            <MessageBox messages={messages as GraphQLMessage[]} location="goal_overview_ira_contributions">
              <MessageBox.After>
                <Separator css={{ fullWidthWithInset: 'space.25' }} />
              </MessageBox.After>
            </MessageBox>
          )}
          <Separator />
          <SambaAutoLink to={urlBuilder.appIraDetails.absolute()}>See details</SambaAutoLink>
        </Box>
      </Card.Content>
    </Card>
  );
};
export default Controller;
